export enum Platform {
    Web,
    iOS,
    Android,
    MacOS,
    Win8,
}
